<template>
  <div>
    <el-dialog @close="closeDialog" :title="$t('lang.switchCrad.switchCradRecord')" :visible.sync="show" @open="refresh"
      width="1120px">
      <div class="header">
        <el-date-picker v-model="time" type="datetimerange" :range-separator="$t('lang.Monitor.to')"
          :start-placeholder="$t('lang.switchCrad.startDate')" :end-placeholder="$t('lang.switchCrad.endDate')"
          size="mini" @change="timeChanger" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <el-button type="primary" size="mini" @click="refresh">{{
          $t("lang.switchCrad.Inquire")
        }}</el-button>
      </div>
      <el-table :data="list" style="margin-top: 10px;width:100%;" border>
        <el-table-column type="index" :label="$t('lang.switchCrad.serialNumber')" align="center"
          width="80px"></el-table-column>
        <el-table-column :label="$t('lang.switchCrad.OperatorFront')" align="center" width="140px">
          <template slot-scope="scope">
            <span>{{ operatorObj[scope.row.beforeMode] ? operatorObj[scope.row.beforeMode] : scope.row.beforeMode }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.switchCrad.ICCIDFront')" align="center" width="180px"
          property="beforeIccid"></el-table-column>
        <el-table-column :label="$t('lang.switchCrad.SignalFront')" align="center" width="110px"
          property="beforeRssi"></el-table-column>
        <el-table-column :label="$t('lang.switchCrad.operatorRear')" align="center" width="120px">
          <template slot-scope="scope">
            <span>{{ operatorObj[scope.row.afterMode] ? operatorObj[scope.row.afterMode] : scope.row.afterMode }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.switchCrad.ICCIDRear')" align="center" width="180px"
          property="afterIccid"></el-table-column>
        <el-table-column :label="$t('lang.switchCrad.SignalRear')" align="center" width="110px"
          property="afterRssi"></el-table-column>
        <el-table-column property="switchTime" :label="$t('lang.switchCrad.ChekaTime')" align="center"></el-table-column>
      </el-table>
      <pagination :total="total" :offset="offset" :limit="limit" @SizeChanges="SizeChanges"
        @CurrentChanges="CurrentChanges"></pagination>
      <div slot="footer" class="footer">
        <el-button @click="show = false" size="mini">{{
          $t("lang.switchCrad.Cancel")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/axios/http.js";
import pagination from "@/components/pagination";
export default {
  name: "switchCard",
  components: {
    pagination,
  },
  data() {
    return {
      show: false,
      list: [],
      time: [
        new Date(Date.now() - 1000 * 60 * 60 * 12)
          .toLocaleString("zh")
          .replace(/[\/]/g, "-"),
        new Date().toLocaleString("zh").replace(/[\/]/g, "-"),
      ],
      total: 0,
      offset: 1,
      limit: 10,
      operatorObj: {
        'China Mobile': "中国移动",
        'China Unicom': "中国联通",
        'China Telecom': "中国电信",
      },
      type: "",
      deviceDid: "",
    };
  },
  methods: {
    refresh() {
      http({
        url: "/api/device/smartcardRecordList",
        method: "post",
        data: {
          type: this.type,
          sts: this.time[0],
          ets: this.time[1],
          offset: this.offset,
          limit: 10,
          did: this.deviceDid,
        },
      }).then((res) => {
        if (res.data.code == 0) {
          this.list = res.data.data.list;
          this.total = res.data.data.total;
        } else {
          this.$message({
            type: "error",
            message: this.$t("lang.onAndOf.GetFailed"),
          });
        }
      });
    },
    SizeChanges(v) {
      this.limit = v;
      this.refresh();
    },
    CurrentChanges(v) {
      this.offset = v;
      this.refresh();
    },
    timeChanger() {
      this.refresh();
    },
    closeDialog() {
      this.time = [
        new Date(Date.now() - 1000 * 60 * 60 * 12)
          .toLocaleString("zh")
          .replace(/[\/]/g, "-"),
        new Date().toLocaleString("zh").replace(/[\/]/g, "-"),
      ];
    },
  },
};
</script>
<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.footer {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
